var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMealPlan = function SvgMealPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    fillRule: "evenodd",
    d: "M18 11.167c.46 0 .833.373.833.833a6.84 6.84 0 0 1-4.218 6.314 6.8 6.8 0 0 1-2.615.52.833.833 0 0 1-.833-.834v-6c0-.46.373-.833.833-.833zm-5.167 5.93c.391-.064.776-.17 1.144-.323a5.17 5.17 0 0 0 3.12-3.94h-4.264z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M7 10.183a.15.15 0 0 1-.15.15h-2.7a.15.15 0 0 1-.15-.15V8.817a.15.15 0 0 1 .15-.15h2.7a.15.15 0 0 1 .15.15zM7 7.183a.15.15 0 0 1-.15.15h-1.7a.15.15 0 0 1-.15-.15V5.817a.15.15 0 0 1 .15-.15h1.7a.15.15 0 0 1 .15.15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    fillRule: "evenodd",
    d: "M7.471 1.318a7.84 7.84 0 0 1 8.041 3.33A7.83 7.83 0 0 1 16.833 9c0 .46-.372.833-.832.833H9.833V16c0 .46-.373.833-.833.833A7.833 7.833 0 0 1 7.47 1.318m.696 1.573a6.167 6.167 0 0 0-2.593 11.236 6.2 6.2 0 0 0 2.593.982zm1.666 5.276h5.276A6.17 6.17 0 0 0 9.833 2.89z",
    clipRule: "evenodd"
  })));
};
export default SvgMealPlan;